import { Resource } from "./resource";
import { ResourceItem } from "./resources/ResourceItem";

export interface DetailActions<TDetail extends ResourceItem> {
  fetchItem(id: string | number): Promise<TDetail>;
}
export type DetailResource<TDetail extends ResourceItem = any> = Resource<
  DetailActions<TDetail>
>;

export function createDetailResource<TDetail extends ResourceItem>(
  apiUrl: string,
  dataTransform: (data: any) => TDetail,
): DetailResource<TDetail> {
  return (client) => ({
    async fetchItem(id) {
      const resp = await client.get(`${apiUrl}${id}/`);
      return dataTransform(resp.data);
    },
  });
}
